<template>
  <div class="public-header">
    <b-navbar class="is-hidden-touch navbar-desktop"  :class="$route.meta.showTransparentNavbar ? 'transparent-navbar' : 'dark-navbar'" >
      <template slot="brand">
        <div class="navbar-item mt-5">
          <router-link to="/">
            <!-- render image if hasbackgroundimage is true -->
            <img src="../assets/img/aham-wp-logo-white.svg" class="header-logo-desktop" />
          </router-link>
        </div>
      </template>
      <template slot="start">
        <div class="navbar-end" style="margin-left: 0;">
          <!-- Insights -->
          <b-dropdown :triggers="['hover']" aria-role="list" class="navbar-item" v-if="!hideNavBar">
            <template #trigger>
              <router-link :to="{ name: 'index'}">
                <b-button type="is-ghost" label="Insights" style="font-weight: 900;" @mouseenter="filterMenu(1)"/>
              </router-link>
            </template>
            <div class="dropdown-wrapper is-flex">
              <div class="column mr-6">
                <router-link v-for="insight, i in menuSelected.slice(0,2)" :key="i" :to="{ name: insight.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{insight.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column mr-6">
                <router-link v-for="insight, i in menuSelected.slice(2,4)" :key="i" :to="{ name: insight.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{insight.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column">
                <router-link v-for="insight, i in menuSelected.slice(4,6)" :key="i" :to="{ name: insight.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{insight.title}}</b-button><br>
                </router-link>
              </div>
            </div>
          </b-dropdown>
          <!-- Resources -->
          <b-dropdown :triggers="['hover']" aria-role="list" class="navbar-item" v-if="!hideNavBar">
            <template #trigger>
              <router-link :to="{ name: 'main'}">
                <b-button type="is-ghost pl-3" label="Resources" style="font-weight: 900;" @mouseenter="filterMenu(2)"/>
              </router-link>
            </template>
            <div class="dropdown-wrapper is-flex">
              <div class="column mr-6">
                <router-link v-for="resource, i in menuSelected.slice(0,2)" :key="i" :to="{ name: resource.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{resource.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column mr-6">
                <router-link v-for="resource, i in menuSelected.slice(2,4)" :key="i" :to="{ name: resource.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{resource.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column">
                <router-link v-for="resource, i in menuSelected.slice(4,6)" :key="i" :to="{ name: resource.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{resource.title}}</b-button><br>
                </router-link>
              </div>
            </div>
          </b-dropdown>
          <!-- Happenings -->
          <b-dropdown :triggers="['hover']" aria-role="list" class="navbar-item" v-if="!hideNavBar">
            <template #trigger>
              <router-link :to="{ name: 'happenings'}">
                <b-button type="is-ghost pl-3" label="Happenings" style="font-weight: 900;" @mouseenter="filterMenu(3)"/>
              </router-link>
            </template>
            <div class="dropdown-wrapper is-flex">
              <div class="column mr-6">
                <router-link v-for="happenings, i in menuSelected.slice(0,2)" :key="i" :to="{ name: happenings.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{happenings.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column mr-6">
                <router-link v-for="happenings, i in menuSelected.slice(2,4)" :key="i" :to="{ name: happenings.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{happenings.title}}</b-button><br>
                </router-link>
              </div>
              <div class="column">
                <router-link v-for="happenings, i in menuSelected.slice(4,6)" :key="i" :to="{ name: happenings.path}">
                  <b-button type="is-ghost" style="background: #F3F3F3;">{{happenings.title}}</b-button><br>
                </router-link>
              </div>
            </div>
          </b-dropdown>
          <!-- Career -->
          <b-navbar-item>
            <router-link :to="{ name: 'careers'}" class="navbar-item" v-if="!hideNavBar" style="background-color: transparent !important;">
              <b-button class="px-0 pl-3" type="is-ghost" label="Career" style="font-weight: 900;"/>
            </router-link>
          </b-navbar-item>
           <!-- About Us -->
           <b-navbar-item>
            <router-link :to="{ name: 'about-us'}" class="navbar-item" v-if="!hideNavBar" style="background-color: transparent !important;">
              <b-button class="px-0 pl-3" type="is-ghost" label="About Us" style="font-weight: 900;"/>
            </router-link>
           </b-navbar-item>
          <!-- Contact -->
          <b-navbar-item>
            <router-link :to="{ name: 'contact-us'}" class="navbar-item" v-if="!hideNavBar" style="background-color: transparent !important;">
              <b-button class="pl-0 pl-3" type="is-ghost" label="Contact Us" style="font-weight: 900;"/>
            </router-link>
          </b-navbar-item>


          <!-- Hide consultant button in desktop version -->
          <span class="navbar-item">
            <!-- <a v-if="!isAuthenticated" class="button is-inverted" style="width: 130px; height: 40px; background-color: #662D90;" @click="login">
              <p class="consultant-btn" style="font-size: medium; font-weight: 500; line-height: 31px; color: #FFF !important;">CONSULTANT</p>
            </a> -->
            <b-dropdown class="consultant-dropdown" aria-role="list" v-if="isAuthenticated">
              <template #trigger>
                <div class="is-flex is-align-items-center is-clickable" @click="filterMenu(0)">
                  <div class="profile-photo" style="">
                    <img class="mr-2 img-profile" :src="$store.state.user.picture" />
                  </div>
                  <div class="bold-l2 color-white is-capitalized profile-name">{{ $store.state.user.name }}</div>
                </div>
              </template>

              <div v-for="menuLabel, index in insideMenu.slice(0,3)" :key="index">
                  <b-dropdown-item aria-role="listitem"
                      @click="redirectPage(menuLabel.path)"
                      style="font-size: medium; color: #FFF; font-weight: 500; background-color: #2B2D47;">
                      {{menuLabel.title}}
                  </b-dropdown-item>
              </div>
              <b-dropdown-item aria-role="listitem"
                  @click="logout"
                  style="font-size: medium; color: #FFF; font-weight: 500; background-color: #2B2D47;">
                  Sign out
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </div>
      </template>
      <template slot="end">
          <!-- Hide Consultant Login button -->
          <!-- Consultant Login -->
          <div class="navbar-item" v-if="!hideNavBar">
            <b-button v-if="!isAuthenticated" @click="login" label="Consultant" icon-right="mdi mdi-play" class="consultant-login-btn"></b-button>
          </div>

          <!-- <router-link to="/" class="navbar-item" v-if="!hideNavBar">
            <b-button disabled v-if="!isAuthenticated" label="Consultant" icon-right="mdi mdi-play" class="consultant-login-btn"></b-button>
          </router-link> -->
      </template>
    </b-navbar>

    <!-- Mobile version -->
    <div class="section section-info is-hidden-desktop" style="padding-top: 2rem; padding-bottom: 2rem;">
      <div class="columns is-mobile">
        <!-- Aham logo -->
        <div class="column is-one-thirds" style="display: flex; align-items: center; image-rendering: auto !important; min-width: 200px; margin-left: 12px;">
          <router-link to="/" style="display: flex; ">
            <img class="header-logo-mobile" src="../assets/img/aham-wp-logo-white.png" style="image-rendering: auto !important;"/>
          </router-link>
        </div>
        <div class="column has-text-right mr-4">
          <b-icon class="mt-0" @click.native="openMenu=true" style="color: #FFFFFF; margin-left: 5%; cursor: pointer;" icon="menu" size="is-medium"></b-icon>
          </div>
      </div>
    </div>

    <b-sidebar
      :fullheight="true"
      :fullwidth="true"
      :right="true"
      :overlay="true"
      v-model="openMenu"
    >
      <div class="section pb-5 pt-5 p-4" style="min-height: 100%; background: #2B2D47; overflow-x: hidden !important;">
        <b-menu v-if="!isSelect" class="mt-3">
          <div class="columns is-mobile">
            <!-- Aham logo -->
            <div class="column is-one-fifth pt-4" style="image-rendering: auto !important; min-width: 200px; margin: 12px;">
              <div @click="goToHome">
                <img src="../assets/img/aham-wp-logo-white.png"/>
              </div>
            </div>
            <div class="column has-text-right mr-5 pt-5">
              <b-icon class="mt-0" @click.native="openMenu=false" style="color: white; margin-left: 10%;" icon="close" size="is-medium"></b-icon>
            </div>
          </div>
          <!-- public menu -->
          <b-menu-list>
            <div v-if="isAuthenticated" class="profile-pic-mobile is-flex is-align-items-center is-clickable" @click="filterMenu(0)">
              <div class="profile-photo">
                <img class="mr-2 img-profile" :src="$store.state.user.picture" />
              </div>
              
              <div class="bold-l2 color-white is-capitalized profile-name">{{ $store.state.user.name ? capitalized($store.state.user.name) : '' }}</div>
            </div>
            <b-menu-item v-for="label, publicIndex in publicMenu" :key="publicIndex" class="menu-border" @click="isSelect = true, filterMenu(publicIndex+1)">
              <template #label>
                <span>{{label}}</span>
                <b-dropdown aria-role="list" class="is-pulled-right">
                  <template #trigger>
                      <b-icon class="pb-2 menu-icon" icon="menu-right" size="is-medium"></b-icon>
                  </template>
                </b-dropdown>
              </template>
            </b-menu-item>
            <b-menu-item class="menu-border" @click.native="openMenu=false" label="Career" tag="router-link" :to="{name: 'careers'}"></b-menu-item>
            <b-menu-item class="menu-border" @click.native="openMenu=false" label="About Us" tag="router-link" :to="{name: 'about-us'}"></b-menu-item>
            <b-menu-item class="menu-border"  @click.native="openMenu=false" label="Contact Us" tag="router-link" :to="{name: 'contact-us'}"></b-menu-item>
          </b-menu-list>

           <!-- consultant menu -->
           <b-menu-list v-if="isAuthenticated">
            <hr class="mb-5" style="background-color: #D0D0D0; margin: 25px -50px; height: 1px; opacity: 0.5;">
            <div class="ml-1 pb-title mb-3" style="color: #FDB913;" >CONSULTANT NAVIGATION</div>
            <b-menu-item v-for="menuLabel, consultantIndex in consultantMenu" :key="consultantIndex"
                        :style="consultantIndex + 1 === consultantMenu.length ? 'border-color: transparent' : 'border-color: #17BDC9'"
                        class="menu-border"
                        :label="menuLabel.title"
                        @click.native="openMenu=false"
                        tag="router-link" :to="{name: menuLabel.path}">
            </b-menu-item>
          </b-menu-list>

          <b-menu-list>
            <hr class="mb-5" style="background-color: #D0D0D0; margin: 25px -50px; height: 1px; opacity: 0.5;">
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between; align-items: center;">
              <p v-if="!isAuthenticated" style="color: #FFFFFF; font-weight: 600; padding: 5px;">Consultant Login</p>
              <p v-else style="color: #FFFFFF; font-weight: 600; padding: 5px;">Consultant sign out</p>
              <b-button v-if="!isAuthenticated" @click="login" label="Consultant" icon-right="mdi mdi-play" style="font-weight: 500; background-color: #730039; color: #FFFFFF; border: none; width: 4px 10px;"></b-button>
              <!-- <b-button v-if="!isAuthenticated" disabled label="Consultant" icon-right="mdi mdi-play" style="font-size: 18px; font-weight: 500; background-color: #730039; color: #FFFFFF; border: none; width: 4px 10px;"></b-button> -->
              <b-button v-else label="Sign Out" @click="logout" icon-right="mdi mdi-play" style="font-weight: 500; background-color: #730039; color: #FFFFFF; border: none; width: 4px 10px;"></b-button>
            </div>
          </b-menu-list>
        </b-menu>
        <!-- menu (selected) -->
        <b-menu v-if="isSelect" class="mt-3">
          <div class="columns is-mobile">
            <!-- Back to Menu -->
            <div v-if="!selectUser" @click="isSelect=false" class="is-flex mt-3 ml-4" style="min-width: 250px;">
              <b-icon class="pb-2" style="color: #FFFFFF;" icon="menu-left" size="is-large"></b-icon>
              <p style="color: #FFFFFF; font-size: 20px; font-weight: 500;" class="mt-1">
                Back to Menu
              </p>
            </div>
            <div class="column has-text-right mr-2 pt-4">
              <b-icon class="mt-0" @click.native="openMenu=false" style="color: white; margin-left: 10%;" icon="close" size="is-medium"></b-icon>
            </div>
          </div>
          <b-menu-list>
            <b-menu-item v-if="selectUser" @click="isSelect=false, selectUser=false" class="main-menu" icon="chevron-left" label="Back to menu">Back to menu</b-menu-item>
            <!-- Dynamic title based on which group -->
            <b-menu-item v-if="!selectUser" @click.native="changeMenu" class="main-menu" :label="currentMenu.replace('/', '')"></b-menu-item>
            <b-menu-item v-for="menuItem, index in menuSelected" :key="index" @click.native="openMenu=false" class="sub-menu-list ml-1" tag="router-link" :to="{name: menuItem.path}" :label="menuItem.title"></b-menu-item>
            <b-menu-item v-if="selectUser" @click.native="logout" class="sub-menu-list" style="margin-left: 40px;">
              <template #label>
                <span>Sign out</span>
                <b-dropdown aria-role="list">
                  <template #trigger>
                      <b-icon class="pb-1 pl-5" icon="logout" size="is-small"></b-icon>
                  </template>
                </b-dropdown>
              </template>
            </b-menu-item>
          </b-menu-list>
        </b-menu>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import store from '../store';

  export default {
    data() {
      return {
        selectUser: false,
        hideNavBar: false,
        isSearch: false,
        openMenu: false,
        isSelect: false,
        insideMenu: [     // 0 = Consultant, 1 = Insights, 2 = Resources, 3 = Happenings
          {
            title: 'Consultant Home',
            path: 'consultant-homepage',
            group: 0
          },
          {
            title: 'MAP',
            path: 'pb-map',
            group: 0
          },
          {
            title: 'Digital Form',
            path: 'digital-form',
            group: 0
          },
          {
            title: 'Dose of Motivation',
            path: 'dose-motivation',
            group: 1
          },
          {
            title: 'Daily Dose of News',
            path: 'dose-news',
            group: 1
          },
          {
            title: 'Weekly Market Review',
            path: 'weekly-market-review',
            group: 1
          },
          {
            title: 'Articles',
            path: 'articles',
            group: 1
          },
          // {
          //   title: 'Featured',
          //   path: 'featured',
          //   group: 1
          // },
           {
            title: 'Daily Fund Price',
            path: 'daily-nav',
            group: 2
          },
          {
            title: 'List of Funds',
            path: 'list-of-funds',
            group: 2
          },
          {
            title: 'Fund Announcements',
            path: 'fund-updates',
            group: 2
          },
          {
            title: 'FUNDamentals',
            path: 'fundamentals',
            group: 2
          },
          {
            title: 'Income Distribution Updates',
            path: 'resources-income-dist-updates',
            group: 2
          },
          {
            title: 'Forms',
            path: 'forms',
            group: 2
          },
          {
            title: 'Events',
            path: 'events',
            group: 3
          },
          {
            title: 'Webinars',
            path: 'webinars',
            group: 3
          },
          {
            title: 'Campaigns',
            path: 'campaigns',
            group: 3
          },
          // {
          //   title: 'Trainings',
          //   path: 'training',
          //   group: 3
          // },
          {
            title: 'Gallery',
            path: 'gallery',
            group: 3
          }
        ],
        menuSelected: [],
        publicMenu: ['Insights', 'Resources', 'Happenings'],
        consultantMenu: [
          {title: 'Home', path: 'consultant-homepage'},
          // {title: 'Trainings', path: 'consultant-training'},
          {title: 'Events & Webinars', path: 'events-webinar'},
          {title: 'Campaigns', path: 'campaign'},
          {title: 'Hall of Fame', path: 'hall-of-fame'},
          {title: 'My Resource Centre', path: 'my-resource-centre'}
        ],
        currentMenu: '',
      };
    },

    methods: {
      capitalized(name) {
        return name.toLowerCase().replace(/(^|\s|-|\')(\w)/g, function (match) {
          return match.toUpperCase();
        });
      },
      goToHome() {
        this.openMenu = false

        if(window.location.pathname != '/') {
          this.$router.push('/')
        }
      },
      changeMenu() {
        this.openMenu = false
        this.$router.push(this.currentMenu)
      },
      filterMenu(groupNo){
        if(groupNo === undefined || groupNo === '') {
          return 
        }

        groupNo == 1 ? this.currentMenu = '/insights' : groupNo == 2 ? this.currentMenu = '/resources' : groupNo == 3 ? this.currentMenu = '/happenings' : ''
        this.menuSelected = [];
        this.insideMenu.forEach((e)=>{
          if(e.group === groupNo){
            this.menuSelected.push(e);
          }
        })

        if(!this.isAuthenticated && groupNo == 3) {
          this.menuSelected.splice(2,1)
        }
      },
      login() {
        this.openMenu = false;
        this.$store.dispatch('auth/login');
      },
      logout() {
        this.$store.dispatch('auth/logout');
      },
      redirectPage(pathName) {
        return this.$router.push({ name: pathName});
      }
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters['auth/isAuthenticated']
      },
      companyTel(){
        return this.$store.getters.get_company_tel;
      },
      companyEmail(){
        return this.$store.getters.get_company_email;
      },
      companyLogoWhite(){
        return this.$store.getters.get_company_logo('white');
      },
      companyLogoColor(){
        return this.$store.getters.get_company_logo('colored');
      }
    },
  }
</script>

<style>

  /* .navbar-item img.profile-photo, .profile-photo{
    border-radius: 50%;
    object-fit: cover;
  } */

  .profile-photo  {
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
  }

  .img-profile {
    width: 100% !important;
    height: 100% !important;
    object-fit: fill;
    border-radius: 50%;
    max-height: none !important;
  }

  .navbar-desktop {
    margin: auto;
    padding: 1.5rem 3rem;
    justify-content: center;
  }

  .header-logo-desktop{
    max-width: 350px;
    width: auto;
    height: auto;
    /* padding-left: 110px; */
  }

  .header-logo-mobile {
    max-width: 200px;
  }

  .navbar-start{
    margin-left: 150px;
    margin-right: 0;
  }
  
  .navbar-end {
    margin-left: 0;
  }

  .menu-list {
    list-style: none;
    padding: 0px;
  }

  .carousel-arrow .is-hovered{
    position: absolute !important;
    top: 90% !important;
    right: 40% !important;
  }

  .menu-list a.is-active, .menu-list a:hover{
    background: transparent;
  }

  .menu-list .menu-border a, .menu-list {
    font-weight: 700;
    line-height: 22px;
    padding-left: 5px;
    color: white;
    list-style-type: none;
  }

  .menu-icon{
    color: #FFFFFF;
    margin-right: 10px;
  }

  .sub-menu-list > a {
    color: #FFFFFF !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
  }

  .menu-list .contact-details a{
    color: white;
    font-size: 16px !important;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .menu-list .main-menu a{
    color: #FDB913 !important;
    font-size: 20px !important;
    font-weight: 700;
    text-transform: uppercase;
  }

  .consultantBtn{
    justify-content: left;
    margin-bottom: 50px;
    border-radius: 8px;
    font-size: 24px;
    font-weight: 500;
    color: #662D90;
    text-transform: uppercase;
  }

  .button.is-ghost:focus {
    outline: 0 !important;
    box-shadow: none !important;
  }

  /* .button.is-ghost > a.active {
    border-bottom: 3px solid red;
  } */

  .consultant-login-btn {
    font-size: 1rem;
    font-weight: 400;
    background-color: #730039;
    color: #FFFFFF;
    border: none;
    margin-left: 50px;
    &:hover, &:active, &:focus {
      background-color: #730039;
      color: #FFFFFF;
    }

    &:disabled {
      background-color: #730039;
    }
  }

  .navbar {
    align-items: center;
  }

  nav.navbar {
    margin-bottom: 0;
  }

  .navbar-start {
    margin-left: 0.5rem;
  }

  .transparent-navbar {
    background-color: transparent !important;
    color: #FFFFFF !important;
  }

  .transparent-navbar:hover {
    transition: all 0.3s ease;
    background-color: #2B2D47 !important;
    color: #FFFFFF !important;
  }

  .transparent-navbar > .navbar-item:active {
    text-decoration: underline;
    color: #FFFFFF;
  }

  .dark-navbar {
    background-color: #2B2D47;
    color: #FFFFFF;
  }

  .transparent-navbar > .navbar-item:active {
    text-decoration: underline;
    color: #FFFFFF;
  }

  .top-header{
    font-weight: 600;
    color: #2F469C;
    text-align: right;
    padding: 10px;
    margin-right: 100px;
  }

  .dropdown + .dropdown{
    margin-left: 0px;
  }

  a.navbar-item {
    padding-right: 2rem;
  }

  .navbar-item, .navbar-link{
    padding-right: 1rem;
    padding-left: 0px;
    height: 0px;
    &:last-child {
      padding-right: 0;
    }
  }

  .navbar-item {
    .columns {
      padding: 1rem 9rem;
      .button.is-ghost {
        margin-bottom: 0.5rem;
      }
    }
  }

  .dropdown-content{
    background: #2B2D47;
  }

  .dropdown-menu-animation.navbar-item {
    position: unset !important;

  }

  .dropdown-menu {
    width: 100%;
    transition: all 0.3s ease;
  }

  .dropdown-content {
    border-top: 1px solid #D0D0D0 !important;
    width: 100% !important;
    display: block !important;
    position: absolute !important;
    top: 0 !important;
    min-width: unset !important;
    left: 0 !important;
    padding-top: 0 !important;
    margin-top: 0 !important;
    border-radius: 0 !important;
  }

  .dropdown-trigger {
    padding: 1.5rem 0;
  }

  /* .dropdown-content .button.is-ghost.active {
    border-bottom: 3px solid #FFFFFF;
  }

  .navbar-item .button.is-ghost.router-link-exact-active {
    border-bottom: 3px solid #FFFFFF;
  } */

  .dropdown.consultant-dropdown .dropdown-menu, .dropdown.consultant-dropdown .dropdown-content {
    background: #2B2D47 !important;
    border-radius: 3px;
    width: 100%;
  }

  .button.is-ghost {

    &:hover, &:active {
      text-decoration: underline 3px;
      text-underline-offset: 12px;
    }
  }

  .router-link-active, .router-link-exact-active {
    .button.is-ghost {
      text-decoration: underline 3px;
      text-underline-offset: 12px;
    }
  }

  .button.is-ghost, a.navbar-item, .navbar-link {
    color: #FFFFFF;
    font-weight: 500;
    background: transparent !important;
    font-size: 1.2rem;
    font-family: 'Open Sans' !important;
    /* padding: 10px; */
    text-align: left;
  }

  .button.is-ghost:hover, a.navbar-item, .navbar-link {
    color: #FFFFFF;
    background: #2B2D47;
  }

  .dropdown{
    text-align: left !important;
  }

  @media screen and (min-width: 1024px) {
    .public-header {
      .navbar-menu:hover  {
        transition: background-color 0.3s linear;
      }
      &.nav-up{
        background-color: #2B2D47;
        /* opacity: 0.9; */
        width:100% !important;
        z-index:99999;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        transition: all 0.3s ease-in;
        .navbar-menu:hover  {
          transition: background-color 0.3s ease-in;
        }
      }

      &.nav-down {
        opacity: 0;
        width: 100%;
        top: -120px;
        z-index:99999;
        position: sticky;
        position: -webkit-sticky;
        transition: all 0.5s ease-out;
        transform: translateY(-166px);
      }

    }

    .navbar-menu {
      flex-grow: unset;
      flex-shrink: unset;
    }
  }

  @media screen and (max-width:1023px){

    .button.is-ghost, a.navbar-item, .navbar-link{
      background: #2B2D47;
      font-size: 16px;
    }

    .menu-list .main-menu a{
      color: #FDB913 !important;
      font-size: 18px !important;
      font-weight: 700;
      text-transform: uppercase;
    }

    .profile-pic-mobile {
      margin: 0 0 1.25rem;
    }

    a.button.is-inverted{
      width: 120px !important;
      height: 40px !important;
    }

    a.navbar-item, .consultant-btn{
      font-size: 16px !important;
    }

    .public-header {
      position: relative;
      z-index: 1;
      .section {
        background-color: #2B2D47 !important;
      }

      .transparent-navbar {
        &~.section {
          background-color: transparent !important;
        }
      }
    }

    .dropdown.is-mobile-modal .dropdown-menu{
      width: 100%;
    }

    .dropdown .background{
      top: 200px;
    }

    .dropdown-trigger {
      padding: 0;
    }

    .dropdown-content{
      background-color: transparent;
    }

    .control.has-icons-left .input, .icon.is-left{
      border-radius: 100px !important;
      font-weight: 400;
      font-size: 22px;
      color: #5C5D64 !important;
    }

    .control.has-icons-left .icon.is-left{
      padding-left: 20px;
    }

    .top-header{
      margin-right: 0px !important;
    }

    .navbar{
      padding-left: 10px !important;
      padding-right: 0px !important;
    }

    .is-hidden-desktop.navbar-item{
      margin-left: 300px !important;
    }

    .hero-body{
      padding-right: 10px !important;
    }
  }

  @media screen and (max-width: 355px) {
    .menu-list .contact-details a{
      font-size: 14px !important;
      margin-bottom: 10px !important;
    }

    .header-logo-mobile {
      max-width: 180px !important;
      margin: 10px;
    }

    .public-header {
      background: transparent;
    }
  }


  @media screen and (min-width:1024px) and (max-width:1215px) {

    .navbar-item img{
      width: 200px;
    }

    .navbar-item img.profile-photo, .profile-photo {
      width: 30px;
      height: 30px;
    }

    .profile-name {
      display: none;
    }

    .navbar-brand {
      .navbar-item {
        padding-right: 0;
      }
    }

    .navbar-desktop{
      padding: 1rem 3rem;
    }

    .navbar-item {
      .button.is-ghost {
        padding-right: 0.5rem !important;
        padding-left: 0.5 !important;
      }
    }

    a.navbar-item {
      padding-right: 0rem !important;
      &:last-child {
        padding-right: 0.5rem !important;
      }
    }

    .consultant-login-btn {
      margin-left: 0;
    }

    .dropdown-wrapper {
      max-width: 580px;
      justify-content: center; 
      margin: auto
    }

  }

  @media screen and (min-width:1216px) and (max-width:1407px) {

    .navbar-item img{
      width: 258px;
      height: auto;
    }

    .navbar-item img.profile-photo, .profile-photo {
      width: 32px;
      height: 32px;
    }

    .navbar-brand {
      .navbar-item {
        padding-right: 0;
      }
    }

    .navbar-desktop{
      padding: 1rem 3rem;
    }

    .dropdown-wrapper {
      max-width: 590px;
      justify-content: center; 
      margin: auto
    }

    .consultant-login-btn {
      margin-left: 1rem;
    }

  }

  @media screen and (min-width:1408px) and (max-width:1660px) {

    .navbar-item img{
      width: 258px;
      height: auto;
    }

    .navbar-item img.profile-photo , .profile-photo {
      width: 34px;
      height: 34px;
    }

    .navbar-desktop{
      padding: 1rem 3rem;
    }

    .dropdown-wrapper {
      max-width: 700px;
      justify-content: center; 
      margin: auto
    }

    a.navbar-item {
      padding-right: 1.5rem;
    }

    .navbar-item, .navbar-link{
      padding-right: 0.5rem;
    }

  }

  @media screen and (max-width: 1023px) {
    .navbar-item img.profile-photo, .profile-photo {
      width: 40px;
      height: 40px;
    }
  }

  @media screen and (min-width: 1661px) {
    .navbar-desktop{
      margin: auto;
      padding: 1.5rem 3rem;
      justify-content: center;
    }

    .navbar-brand {
      .navbar-item {
        padding-right: 1.5rem;
      }
    }

    .navbar-item img{
      width: 258px;
      height: auto;
      padding-left: 0;
    }

    .navbar-item img.profile-photo, .profile-photo {
      width: 40px;
      height: 40px;
    }

    /* .button.is-ghost{
      padding-left: 50px;
    } */

    .daily-insight-btn{
      padding-left: 0px;
    }

    .dropdown-wrapper {
      max-width: 900px;
      justify-content: center; 
      margin: auto
    }

    /* .button.is-ghost, a.navbar-item, .navbar-link {
      font-size: 24px;
    } */

    a.navbar-item {
      padding-right: 1.5rem;
    }

    .navbar-item, .navbar-link{
      padding-right: 0.5rem;
    }

    .dropdown-trigger {
      padding: 2rem 0;
    }

  }
</style>